export default __webpack_public_path__ + "static/guides-cta-fa945bca72c143ef7b0640b3d9977aa1.png";